import {
    PostSpring2023ExamCode,
    PreSpring2023ExamCode,
    SourceType,
} from './ExamChangeGuidePage.types'

export const hashExamChangeAnalysisKey = (input: {
    newExamCode: PostSpring2023ExamCode
    previousExamCode: PreSpring2023ExamCode
    sourceType: SourceType
}): string => {
    const { newExamCode, previousExamCode, sourceType } = input
    return `${newExamCode}|${previousExamCode}|${sourceType}`
}

export const unhashExamChangeAnalysisKey = (
    hashedInput: string
): {
    newExamCode: PostSpring2023ExamCode
    previousExamCode: PreSpring2023ExamCode
    sourceType: SourceType
} => {
    const [newExamCode, previousExamCode, sourceType] = hashedInput.split('|')
    return {
        newExamCode: newExamCode as PostSpring2023ExamCode,
        previousExamCode: previousExamCode as PreSpring2023ExamCode,
        sourceType: sourceType as SourceType,
    }
}
